/** Point-in-polygon. Ring is GeoJSON `[lng, lat]` pairs (closed or open). */

import {enToLatLng, simToEn} from "./sim_cam_geo.js"

export const REDACT_WARN = "The hologram is hidden from here."


export function pointInRing(lng, lat, ring) {
  if (!Array.isArray(ring) || ring.length < 3) return false
  const open = openRing(ring).map(coercePair).filter(Boolean)
  const n = open.length
  if (n < 3) return false
  lng = Number(lng)
  lat = Number(lat)
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return false
  let inside = false
  let [x0, y0] = open[n - 1]
  for (let i = 0; i < n; i++) {
    const [x1, y1] = open[i]
    const crosses = y1 > lat !== y0 > lat && lng < ((x0 - x1) * (lat - y1)) / (y0 - y1) + x1
    if (crosses) inside = !inside
    x0 = x1
    y0 = y1
  }
  return inside
}

function coercePair(pt) {
  if (!Array.isArray(pt) || pt.length < 2) return null
  const lng = Number(pt[0])
  const lat = Number(pt[1])
  if (!Number.isFinite(lng) || !Number.isFinite(lat)) return null
  return [lng, lat]
}

export function pointInRedactPolygons(lat, lng, polygons) {
  if (!Array.isArray(polygons)) return false
  return polygons.some((poly) => pointInRing(lng, lat, ringOf(poly)))
}

export function parseRedactPolygonsJson(raw) {
  try {
    if (!raw) return []
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

/** Sim camera ENU is around the current pin; polygons stay geographic. */
export function simCamRedacted(originLat, originLng, simX, simZ, polygons) {
  if (!Number.isFinite(originLat) || !Number.isFinite(originLng)) return false
  const {east, north} = simToEn(simX, simZ)
  const {lat, lng} = enToLatLng(originLat, originLng, east, north)
  return pointInRedactPolygons(lat, lng, polygons)
}

function ringOf(poly) {
  const coords = poly && poly.polygon && poly.polygon.coordinates
  if (!Array.isArray(coords) || !Array.isArray(coords[0])) return []
  return coords[0]
}

function openRing(ring) {
  if (ring.length >= 2) {
    const a = ring[0]
    const b = ring[ring.length - 1]
    if (a[0] === b[0] && a[1] === b[1]) return ring.slice(0, -1)
  }
  return ring.slice()
}
